<template>
    <div>
      <div class="navBox">
        <div class="navTop">
          <div class="leftLogo" @click="navClick(1,'/')"><img src="../../../assets/icon/nb__about.png"/></div>
          <div class="rightMenuIcon" @click="openMenu()"><img src="../../../assets/icon/navMenuIcon.png"/></div>
        </div>
        <div class="navList" v-if="show.nav" @click="show.nav=false">
          <div class="navListBox" @click.stop>
            <ul class="navListUl">
              <li class="navListLi" :class="act.navIndex===1 ? 'act' : ''" @click="navClick(1,'/')">HOME</li>
              <li class="navListLi" :class="act.navIndex===2 ? 'act' : ''" @click="navClick(2,'/about_m')">ABOUT</li>
              <li class="navListLi notBorder" @click="openNav2">
                <div class="navDiv" :class="act.navIndex===3 ? 'act' : ''">
                  PAYMENT SOLUTIONS
                  <img class="icon" src="../../../assets/icon/nav_icon.png" />
                </div>
                <ul class="navListUl2" v-if="show.nav2">
                  <li class="navListLi2" :class="act.navIndex1===1 ? 'act' : ''" @click="navClick(3,'/PaymentInstore_m')">Instore solution</li>
                  <li class="navListLi2" :class="act.navIndex1===2 ? 'act' : ''" @click="navClick(3,'/PaymentOnline_m')">Online solution</li>
                </ul>
              </li>
              <li class="navListLi" :class="act.navIndex===4 ? 'act' : ''" @click="navClick(4,'/services_m')">SERVICES</li>
              <li class="navListLi" :class="act.navIndex===5 ? 'act' : ''" @click="navClick(5,'/ourApp_m')">OUR APP</li>
              <li class="navListLi" :class="act.navIndex===6 ? 'act' : ''" @click="navClick(6,'/Partners_m')">PARTNERS</li>
              <li class="navListLi" :class="act.navIndex===7 ? 'act' : ''" @click="navClick(7,'/apply_m')">CONTACT</li>
              <li class="navListLi" :class="act.navIndex===7 ? 'act' : ''" @click="switchLang()">中文</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "topNav",
      data() {
        return{
          act:{
            navIndex:1,
            navIndex1:0,
          },
          show:{
            nav:false,
            nav2:false

          }
        }
      },
      mounted () {
        var pages=this.$route.name;
        if(pages === "home_m"){
          this.act.navIndex=1;
        }else if(pages === "about_m"){
          this.act.navIndex=2;
        }else if(pages === "PaymentInstore_m" || pages === "PaymentOnline_m"){
          if(pages === "PaymentInstore_m"){
            this.act.navIndex1=1;
          }else if(pages === "PaymentOnline_m"){
            this.act.navIndex1=2;
          }
          this.act.navIndex=3;
          this.show.nav2=true;
        }else if(pages === "services_m"){
          this.act.navIndex=4;
        }else if(pages === "ourApp_m"){
          this.act.navIndex=5;
        }else if(pages === "Partners_m"){
          this.act.navIndex=6;
        }else if(pages === "apply_m"){
          this.act.navIndex=7;
        }

        // window.addEventListener('scroll', this.handleScroll);

      },
      methods:{
        //  点击导航
        navClick(index,url){
          this.act.navIndex=index;
          this.$router.push(url);
          this.show.nav=false;
        },
        openMenu(){
          this.show.nav = !this.show.nav;
        },
        openNav2(){
          this.show.nav2 = !this.show.nav2;
        },
        switchLang(){
          this.$router.push('/homeCn_m');
        }
      }
    }
</script>

<style scoped>
  .navBox{width: 100%;height: auto;position: fixed;top: 0;z-index: 999;}
  .navBox .navTop{width:calc(100% - 30px);height: 3.5rem; padding: 0 15px;background-color: #000;}
  .navBox .navTop .leftLogo{width: 50%;height: 100%; float: left;display: flex;align-items: center;}
  .navBox .navTop .leftLogo>img{width: 7.68rem;align-items: center;}
  .navBox .navTop .rightMenuIcon{width: 1.75rem;height: 100%;float: right;text-align: right;display: flex;align-items: center;}
  .navBox .navTop .rightMenuIcon>img{width: 100%; align-items: center;margin-right: 0;}
  .navBox .navList{width: 100%; height: 100%;position: fixed;top: 3.5rem;z-index: 999; background-color: rgba(0,0,0,0);}
  .navBox .navList .navListBox{width:calc(100% - 30px);height: auto; padding: 10px 15px;background-color: #000;}
  .navBox .navList .navListUl{width:100%;height: auto; padding: 10px 0;border-top: 1px solid rgba(255,255,255,0.6);}
  .navBox .navList .navListUl .navListLi{width: calc(100% - 40px);padding: 0.8rem 0;margin: auto; color: rgba(255,255,255,0.6);border-bottom: 1px solid rgba(255,255,255,0.3);}
  .navBox .navList .navListUl .navListLi.act{color: #fff;}
  .navBox .navList .navListUl .navListLi:hover{color: #fff;}
  .navBox .navList .navListUl .navListLi:last-of-type{border: 0;}
  .navBox .navList .navListUl .navListLi .navListUl2{width: calc(100% - 20px);padding-left: 20px;}
  .navBox .navList .navListUl .navListLi .navListUl2 .navListLi2{width: 100%;padding: 0.8rem 0;color: rgba(255,255,255,0.6);border-bottom: 1px solid rgba(255,255,255,0.3);}
  .navBox .navList .navListUl .navListLi .navListUl2 .navListLi2.act{color: #fff;}
  .navBox .navList .navListUl .navListLi.notBorder{border: 0;padding: 0;}
  .navBox .navList .navListUl .navListLi .navDiv{width: 100%;padding: 0.8rem 0;border-bottom: 1px solid rgba(255,255,255,0.3);display: flex;align-items: center;}
  .navBox .navList .navListUl .navListLi .navDiv.act{color: #fff;}
  .navBox .navList .navListUl .navListLi .navDiv .icon{float: right;margin-left: 50px;align-items: center;}
</style>
